export default __webpack_public_path__ + "static/media/lunch-bread.afc8eef1.webp";